__turbopack_context__.v({
  "container": "BundleAddModal-module-scss-module__RYzIrW__container",
  "cta": "BundleAddModal-module-scss-module__RYzIrW__cta",
  "description": "BundleAddModal-module-scss-module__RYzIrW__description",
  "error": "BundleAddModal-module-scss-module__RYzIrW__error",
  "footer": "BundleAddModal-module-scss-module__RYzIrW__footer",
  "line": "BundleAddModal-module-scss-module__RYzIrW__line",
  "lineMessage": "BundleAddModal-module-scss-module__RYzIrW__lineMessage",
  "lineQuantity": "BundleAddModal-module-scss-module__RYzIrW__lineQuantity",
  "lines": "BundleAddModal-module-scss-module__RYzIrW__lines",
  "loading": "BundleAddModal-module-scss-module__RYzIrW__loading",
  "message": "BundleAddModal-module-scss-module__RYzIrW__message",
  "srOnly": "BundleAddModal-module-scss-module__RYzIrW__srOnly",
  "total": "BundleAddModal-module-scss-module__RYzIrW__total",
});
